"use client";

import { useId, type RefObject } from "react";

export function FormHoneypot({ inputRef }: { inputRef: RefObject<HTMLInputElement | null> }) {
  const id = useId();
  return (
    <div
      aria-hidden="true"
      style={{ position: "absolute", width: 1, height: 1, padding: 0, margin: -1, overflow: "hidden", clipPath: "inset(50%)", whiteSpace: "nowrap", pointerEvents: "none" }}
    >
      <label htmlFor={id}>Leave this field empty</label>
      <input
        aria-hidden="true"
        autoComplete="off"
        data-1p-ignore
        data-lpignore="true"
        id={id}
        name="website"
        ref={inputRef}
        tabIndex={-1}
        type="text"
      />
    </div>
  );
}
